import React, { Component } from 'react';
import { connect } from 'react-redux';
import CardWidget from "../card-widget/CardWidget";
import { RouteConstants } from "../route/services/RouteConstants";
import Api from "../../services/api/Api";
import { ApiPaths } from "../../services/api/ApiPaths";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import CardWidgetErrorsContainer from "../card-widget/CardWidgetErrorsContainer";
import CardWidgetTextInput from "../card-widget/CardWidgetTextInput";
import { getLanguage } from "../../store/rootReducer";
import UrlParamsUtil from "../../services/util/UrlParamsUtil";
import ValidationService from '../registration/services/ValidationService';
import { USER_CREATION_STATE } from "../common/UserCreationState";

class PasswordForceResetInitialization extends Component {

    constructor(props) {
        super(props);
        this.props = props;
        this.state = {
            errorMessage: null,
            clientId: 'portaloidc',
            email: this.props.location.state.email
        };
    }

    getForgotPasswordContent = () => {
        return (
            <div>
                <CardWidgetContent contentText="student_section.password_force_reset" />
                <CardWidgetErrorsContainer errorMessage={this.state.errorMessage} />
            </div>
        )
    };

    render() {
        return (
            <CardWidget getCardContent={this.getForgotPasswordContent} />
        )
    };
}

const mapStateToProps = (state) => {
    return {
        language: getLanguage(state)
    };
};

export default connect(mapStateToProps)(PasswordForceResetInitialization);